import { useSelector } from 'react-redux';

export const useCurrentUser = () => {
  const { currentUser } = useSelector((state) => state.authReducer);

  return { currentUser, isAuthenticated: !!currentUser };
};
